import React, { Component } from 'react';
import Icons from '../../../components/icon';

class Thead_CustomFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            beforeValue: '',
            columnValues: {}
        }
    }

    handleBlur = (event, key) => {
        const value = event.target.value;
        if (this.state.beforeValue != value) {
            this.props.onColumnSearchChange(event, key)
            this.onColumnSearch(event, key);
        }
    }

    handleFocus = (event) => {
        this.setState({ beforeValue: event.target.value });
    }

    handleClick = (value) => (event) => this.props.onColumnClick(value);
    onColumnSearch = (event, value) => {
        this.setState({ beforeValue: event.target.value });
        this.props.onColumnSearch(value);
    };
    onColumnSearchChange(e, key) {

        this.setState((prevState) => ({
            columnValues: {
                ...prevState.columnValues,
                [key]: e.target.value

            }
        }));

        this.props.onColumnSearchChange(e, key);

        if(e.target.value === "") this.onColumnSearch(e, key);
    };
    
    
    render() {
        //var columns = Object.values(this.props.columns).sort((a, b) => (a.order - b.order))
        var columns = this.props.columns[0] ? Object.values(this.props.columns[0]).sort((a, b) => (a.order - b.order)) : Object.values(this.props.columns).sort((a, b) => (a.order - b.order));
    
        return (
            <thead>
                <tr>
                    {columns.map((value) => {
                        if (!value.hidden) {
                            return (
                                <th className="thead-external" hidden={value.hidden} key={'thead-' + value.name}>
                                <div className="th-table-container">
                                    <div className="thead-table-title" onClick={this.handleClick(value.propName)}>
                                        {value.name}
                                    <div className="icon-sorting">
                                        {
                                            !this.props.isNotSortable &&
                                            (value.isSorted ?
                                                !value.isSortedAsc ?
                                                    <Icons
                                                        name="sort-down-solid"
                                                        size="14px"
                                                        customClassName="icon-table-header"
                                                        containerClass="d-inline-block" /> :
                                                    <Icons
                                                        name="sort-up-solid"
                                                        size="14px"
                                                        customClassName="icon-table-header"
                                                        containerClass="d-inline-block" />
                                                :
                                                <>
                                                    <Icons
                                                        name="sort-up-solid"
                                                        size="14px"
                                                        customClassName="icon-table-header"
                                                        containerClass="d-inline-block" />
                                                    <Icons
                                                        name="sort-down-solid"
                                                        size="14px"
                                                        customClassName="icon-table-header margin-left-neg14-i"
                                                        containerClass="d-inline-block" />
                                                </>)
                                        }
                                            </div>
                                    </div>
                                </div>
                                    {this.props.isColSearchShow
                                        ? <div className="thead-table-custom-filter" >
                                            <input
                                                type="text"
                                                ref={this.textInput}
                                                placeholder="Search..."
                                                maxLength={255}
                                                name={'thead-column-search-' + value.propName}
                                                value={this.state.columnValues[value.propName] || value.searchString ||''}
                                                onChange={e => { this.onColumnSearchChange(e, value.propName) }}
                                                onBlur={(e) => this.handleBlur(e, value.propName)}
                                                onFocus={(e) => this.handleFocus(e) }
                                                onKeyUp={(e) => {
                                                    if (e.key === 'Enter') {
                                                        this.onColumnSearch(e, value.propName);
                                                    }
                                                }}
                                            />
                                        </div>
                                        : ''
                                    }
                                </th>
                            );
                        }
                    })}
                </tr>
            </thead>
        );
    }
}

export default Thead_CustomFilter;
